export const VIEW_STYLE_LIST = 'VIEW_STYLE_LIST';
export const VIEW_STYLE_GRID = 'VIEW_STYLE_GRID';



// WEBPACK FOOTER //
// ./constants/collectionViews.js